import { render } from "./TemplateScholar.vue?vue&type=template&id=23314280&scoped=true"
import script from "./TemplateScholar.vue?vue&type=script&lang=js"
export * from "./TemplateScholar.vue?vue&type=script&lang=js"

import "./TemplateScholar.vue?vue&type=style&index=0&id=23314280&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23314280"]])

export default __exports__